import { render, staticRenderFns } from "./PurchasingBestPractices.vue?vue&type=template&id=3dd6df03&scoped=true&"
import script from "./PurchasingBestPractices.vue?vue&type=script&lang=js&"
export * from "./PurchasingBestPractices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd6df03",
  null
  
)

export default component.exports